var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"battle-academia-items":""}},[_c('OfficialLeagueGameInfoTemplate',{attrs:{"title":_vm.title,"slides":_vm.slides},on:{"more-click":_vm.leagueRewordModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }